import apiFetch from '../apiFetch'

export default function (idConectividad, token) {
  return apiFetch({endPoint: `Conectividad/cambioEstadoMaquina?idMaquina=${idConectividad}`, method: 'GET', body: null, token: token})
}
